import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_ReleaseOfInformation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_ReleaseOfInformation' className='file-pdf-document'>
            <div className='file-template'>


                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Client Name</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-250'><input type='date' id='txtDateBirth' name='txtDateofBirth' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>I hereby request and authorize: Core Solutio of Atlanta Georgia <br />
                    To obtain from/release to:
                </p>

                <table>
                    <tr>
                        <td className='w-750'><input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>the following types
                    of protected health information from my records: Information pertaining to my disability for purposes of employment for accommodations/modifications. <br />
                    1. I understand that the information disclosed pursuant to this Authorization may be
                    subject to disclosure by the recipient and no longer protected by federal privacy
                    regulations or other applicable state or federal laws. <br />
                    2. I understand that Core Solutio will not condition my services, payment, or eligibility
                    for any applicable benefits/services on whether I provide authorization for the
                    requested release of information.<br />
                    3. I intend for this document to be valid authorization conforming to all requirements of
                    this Privacy Rule and state law, and understand that my authorization will remain in
                    effect for: <br /> <br />
                    <center><i>The period necessary to complete all transactions on matters related to services provided to me.</i></center> <br />
                    I understand that unless otherwise limited by state or federal regulation and except to the
                    extent that action has been taken based upon it, I may revoke this authorization at any time
                    by sending written notice of my withdrawal of this authorization to the staff of the provider
                    who is providing services to me at Core Solutio, PO Box 680731, Marietta, GA 30067,
                    Phone: 770-405-9646.
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Date </td>
                        <td className='small w-375'> Client Signature</td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature of (circle or highlight an option below if applicable)</td>
                        <td className='small w-375'>Signature of Witness </td>
                    </tr>
                </table>

                <p className='w-375'>
                    Parent <br />
                    Guardian
                </p>






            </div>
        </form>

    )
}